<template>
    <div>
        <div class="info-box">
            <div class="info-title">
                <h3>基础信息</h3>
                <p></p>
            </div>
            <div class="info-main">      
                <div class="input-box">
                    <p>获奖年度：</p>
                    <a-date-picker
                        class="input"
                        mode="year"
                        format='YYYY年'
                        v-model="info.awardYear" 
                        :open='yearShowOne' 
                        @openChange="openChangeOne"
                        @panelChange="panelChangeOne"/>
                </div>
                <div class="input-box">
                    <p>获奖类别：</p>
                    <a-select class="input" allowClear v-model="info.awardTypeCode" :disabled="type=='look'">
                        <a-select-option v-for="(item,index) in hjlbArr" :key="index" :value="item.dataCode">{{item.dataName}}</a-select-option>
                    </a-select>
                </div>
                <div class="input-box">
                    <p>教学成果名称：</p>
                    <a-input class="input" v-model="info.achievementName" :disabled="type=='look'" />
                </div>
                <div class="input-box">
                    <p>获奖时间：</p>
                    <a-date-picker class="input" v-model="info.awardDate" @change="(date, dateString)=>{info.awardDate=dateString}" :disabled="type=='look'"/>
                </div>
                <div class="input-box">
                    <p>获奖等级：</p>
                    <a-select class="input" allowClear v-model="info.awardLevelCode" :disabled="type=='look'">
                        <a-select-option v-for="(item,index) in hjdjArr" :key="index" :value="item.dataCode">{{item.dataName}}</a-select-option>
                    </a-select>
                </div>
                <div class="input-box">
                    <p>主要完成人：</p>
                    <a-input class="input" v-model="info.participants" :disabled="type=='look'" />
                </div>
            </div>
        </div>
        <div class="info-box">
            <div class="info-title">
                <h3>证书扫描件</h3>
                <p></p>
            </div>
            <a-upload-dragger
                class="upload-box"
                name="file"
                list-type="picture-card"
                :multiple="true"
                :action="$store.state.axiosUrl+'/api-f/files'"
                :headers="headers"
                @change="fileChange"
                :file-list="fileList"
                :disabled="type=='look'"
            >
                <p class="ant-upload-drag-icon">
                    <a-icon type="inbox" />
                </p>
                <p class="ant-upload-text">点击或拖拽文件上传</p>
                <p class="ant-upload-hint">支持单次或批量上传</p>
            </a-upload-dragger>
        </div>
        <div class="btn-box">
            <a-button type="primary" v-if="type!='look'" @click="sub">提交</a-button>
            <a-button @click="$router.go(-1)">取消</a-button>
        </div>
    </div>
</template>
<script>
    import { getDicts } from '@/baseAPI/dictionary'
    import { add,update,info } from '@/baseAPI/undergraduate/culture/achievements'
    export default {
        name: 'teacher',
        components: {
        },
        data () {
            return {
                type:'',
                headers:{
                    'Authorization':'Bearer '+ this.$store.state.access_token
                },
                info:{
                    awardYear:null,
                    awardTypeCode:null,
                    achievementName:null,
                    awardDate:null,
                    awardLevelCode:null,
                    participants:null,
                    certificateUrl:null,
                    fileList:[],
                },
                fileList:[],
                hjlbArr:[],
                hjdjArr:[],
                yearShowOne:false,

            }
        },
        mounted () {
            getDicts({dataCode:'HJLB',status:true}).then(res=>{
                this.hjlbArr=res.data.dicts;
                this.info.awardTypeCode=res.data.defaultValue[0]
            })
            getDicts({dataCode:'HJDJ',status:true}).then(res=>{
                this.hjdjArr=res.data.dicts;
                this.info.awardLevelCode=res.data.defaultValue[0]
            })
            this.type=this.$route.query.type;
            if(this.type!='add'){
                info(this.$route.query.id).then(res=>{
                    this.info=res.data;
                    this.fileList=[];
                    for(let i=0;i<this.info.fileList.length;i++){
                        this.fileList.push({
                            uid: this.info.fileList[i].id,
                            name: this.info.fileList[i].fileName,
                            status: 'done',
                            url: this.$store.state.axiosUrl+this.info.fileList[i].fileUrl,
                        })
                    }
                })
            }

        },
        methods:{
            fileChange(file){
                if(typeof file.file.response!='undefined'){
                    var res=file.file.response;
                    this.$notification['success']({
                        message: '成功',
                        description:'文件上传成功'
                    });
                    this.info.fileList.push({
                        fileName:res.name,
                        fileUrl:res.url
                    })
                }else if(file.file.status=='removed'){
                    var num=this.fileList.indexOf(file.file);
                    this.info.fileList.splice(num, 1)
                }
                console.log(this.info.fileList)
                this.fileList=file.fileList;
            },
            sub(){
                var isSub=true;
                var arr=['certificateUrl','approvalStatus','remark']
                for(let key in this.info){
                    if(arr.indexOf(key)<0){
                        if(this.info[key]==null||this.info[key]===''){
                            isSub=false;
                            break;
                        }
                    }
                }
                if(isSub){
                    if(this.type=='add'){
                        add(this.info).then(res=>{
                            if(res.data.success){
                                this.$notification['success']({
                                    message: '成功',
                                    description:'新增教学成果奖成功',
                                });
                                this.$router.go(-1)
                            }else{
                                this.$notification['error']({
                                    message: '失败',
                                    description:res.data.errorMessage,
                                });
                            }
                        })
                    }else{
                        update(this.info).then(res=>{
                            if(res.data.success){
                                this.$notification['success']({
                                    message: '成功',
                                    description:'修改教学成果奖成功',
                                });
                                this.$router.go(-1)
                            }else{
                                this.$notification['error']({
                                    message: '失败',
                                    description:res.data.errorMessage,
                                });
                            }
                        })
                    }
                }else{
                    this.$notification['warning']({
                        message: '警告',
                        description:'请填写完整！',
                    });
                }
            },
            // 弹出日历和关闭日历的回调
            openChangeOne(status) {
                    if (status){
                        this.yearShowOne =  true
                    }
                },
            // 得到年份选择器的值
            panelChangeOne(value) {
                this.info.awardYear = this.getTimeStr(value._d,'yyyy');
                this.yearShowOne = false;
            },
        }
    }
</script>
<style scoped>
    .info-box{
        margin-bottom: 2rem;
    }
    .info-title{
        position: relative;
        line-height: 3rem;
    }
    .info-title h3{
        font-size: 1.2rem;
        font-weight: bold;
        letter-spacing: 2px;
        padding-left: 10px;
        color: #245086;
    }
    .info-title p{
        position: absolute;
        left: 0;
        bottom: 0;
        width: 50%;
        height: 3px;
        background-image: linear-gradient(to right, #245086 , rgba(36,80,134,0));
    }
    .info-title .ant-btn{
        float: right;
        margin-top: calc(1.5rem - 16px);
        margin-right: 2rem;
    }
    .info-main{
        display: flex;
        flex-wrap: wrap;
        margin-top: 1.5rem;
    }
    .info-main .input-box{
        width: 33%;
        display: flex;
        line-height: 32px;
        margin-bottom: 1.5rem;
    }
    .info-main .input-box-center{
        width: 66%;
    }
    .info-main .input-box-half{
        width: 49.5%;
    }
    .info-main .input-box p{
        width: 10rem;
        text-align: right;
    }
    .info-main .input-box .input{
        width: calc(100% - 12rem);
    }
    .ant-table-wrapper{
        margin-top: 2rem;
    }
    .ant-table-wrapper >>> .ant-empty-normal{
        display: none;
    }
    .text-box{
        display: flex;
        margin-bottom: 0.5rem;
    }
    .text-box p{
        font-size: 1rem;
        line-height: 2rem;
    }
    .text-box .title{
        width: 5rem;
        text-align: right;
    }
    .text-box .text{
        border: 1px solid #ccc;
        padding: 0 10px;
        border-radius: 5px;
    }
    .action-btn{
        color: #40a9ff;
        display: inline-block;
    }
    .ant-table-wrapper >>> .ant-table-thead > tr > th,
    .ant-table-wrapper >>> .ant-table-tbody > tr > td{
        padding: 10px;
    }
    .ant-table-wrapper .input-box{
        width: 100%;
    }
    .btn-box{
        text-align: center;
    }
    .btn-box .ant-btn{
        margin: 0 1rem;
    }
    .upload-box{
        margin-top: 2rem;
        display: block;
    }
    .ant-input[disabled],.ant-select-disabled,.ant-input-number-disabled,.ant-calendar-picker >>> .ant-input[disabled]{
        color: rgba(0, 0, 0, 0.65);
        background-color: transparent;
    }
    .ant-select-disabled >>> .ant-select-selection{
        background-color: transparent;
    }
    .upload-box >>> .ant-upload-list:after{
      content: ".";
      display: block;
      font-size: 0;
      height: 0;
      clear: both;
    }
    .upload-box >>> .ant-upload.ant-upload-disabled{
        display: none;
    }
</style>
